import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export const DEFAULT_FAQS = [
  {
    q: "What time is the Morning Sunday Teer result declared?",
    a: "The First Round (F/R) result is generally announced around 10:30 AM and the Second Round (S/R) result around 11:30 AM (IST). The result card on this site updates automatically once numbers are declared.",
  },
  {
    q: "How do I check today's Morning Sunday Teer result?",
    a: "Simply open any result page on this website. The latest First Round and Second Round numbers appear at the top in the result card, refreshed automatically without reloading the page.",
  },
  {
    q: "What is a common number in Teer?",
    a: "A common number is a frequently referenced number that enthusiasts study from previous result charts. On this site the daily common number is generated using a fixed date-based method, so it stays the same throughout the day.",
  },
  {
    q: "Do the common numbers change on refresh?",
    a: "No. The common number is deterministic for each day and remains stable no matter how many times you refresh. It rolls over to the next day automatically after 8:00 PM (IST).",
  },
  {
    q: "Where can I see previous results?",
    a: "Visit any Previous Result page to browse a responsive, paginated archive of older results including date, city, F/R and S/R numbers.",
  },
  {
    q: "Is this the official Morning Sunday Teer website?",
    a: "No. This is an independent informational platform. We do not operate, organize, sell tickets for, or facilitate any game. All content is provided for general information and entertainment reference only.",
  },
];

export function FAQAccordion({ faqs = DEFAULT_FAQS }) {
  return (
    <section data-testid="faq-accordion-section">
      <h2 className="font-head font-extrabold text-2xl sm:text-3xl text-slate-900 mb-5">
        Frequently Asked Questions
      </h2>
      <Accordion type="single" collapsible className="bg-white rounded-xl border border-slate-200 card-shadow px-4">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-semibold text-slate-900 text-[15px]">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 text-sm leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
